import { cva } from '@/styled-system/css';

export const upsellBodyRecipe = cva({
  base: {
    'marginBlockStart': 'none',

    '& > .c11n_text': {
      color: 'inherit',
      textStyle: 'body',
    },
    '& > .c11n_paragraph': {
      color: 'inherit',
      textStyle: 'body',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.neutral',
      },
      soft: {
        color: 'text.neutral',
      },
      hero: {
        color: 'Upsell.Body.hero.text',
      },
      impact: {
        color: 'text.onImpact.neutral',
      },
    },
  },
});
